import {Component, OnInit} from '@angular/core';
import {DynamicDialogConfig, DynamicDialogRef} from 'primeng/dynamicdialog';
import {SharedImports} from '@shared/shared-imports';
import {Router} from '@angular/router';

@Component({
  selector: 'app-alert-comms-response-dialog',
  templateUrl: './alert-communication-response-dialog.component.html',
  styleUrls: ['./alert-communication-response-dialog.component.scss'],
  imports: [SharedImports]
})

export class AlertCommunicationResponseDialogComponent implements OnInit {
  goToUrl: string;
  body: string;

  constructor(public config: DynamicDialogConfig, public ref: DynamicDialogRef,
              private router: Router) {
  }

  ngOnInit(): void {
    this.body = this.config.data.message;
    console.log(this.body);
    this.goToUrl = this.config.data.goToUrl;
  }

  closeDialog(): void {
    this.ref.close();
  }

  cancel(): void {
    this.closeDialog();
  }

  goToComm() {
    this.closeDialog();
    this.router.navigateByUrl(this.goToUrl);
  }
}
